var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6833 5.28092C47.0697 3.85728 45.0642 3.82138 44.4 5.22214L38.9147 16.7916C38.4424 17.7878 37.1943 18.1302 36.2798 17.5144L25.6595 10.3623C24.3737 9.4964 22.6671 10.5505 22.8657 12.0879L24.5061 24.7864C24.6474 25.8798 23.7825 26.8426 22.6802 26.8189L9.87918 26.544C8.32931 26.5107 7.46351 28.3201 8.46181 29.5061L16.7071 39.3019C17.4171 40.1454 17.21 41.4229 16.2699 41.9989L5.35239 48.6884C4.03056 49.4983 4.28044 51.4886 5.76147 51.9466L17.9939 55.7296C19.0471 56.0553 19.5636 57.242 19.0842 58.2348L13.5164 69.7648C12.8423 71.1608 14.1285 72.7 15.622 72.2846L27.9578 68.8537C29.02 68.5583 30.096 69.2774 30.2295 70.3718L31.7791 83.0816C31.9668 84.6205 33.881 85.22 34.9128 84.063L43.4354 74.5076C44.1693 73.6848 45.4633 73.708 46.1672 74.5565L54.3424 84.4109C55.3322 85.604 57.2666 85.0734 57.5092 83.5423L59.5128 70.896C59.6853 69.8071 60.7864 69.127 61.8373 69.4603L74.0424 73.3305C75.5201 73.7991 76.8606 72.3069 76.2369 70.8877L71.0853 59.1658C70.6418 58.1564 71.2004 56.989 72.2647 56.7011L84.6246 53.3585C86.1211 52.9537 86.442 50.9737 85.1501 50.117L74.4789 43.041C73.5601 42.4317 73.3989 41.1476 74.1386 40.3301L82.7292 30.8357C83.7693 29.6862 82.9689 27.847 81.4188 27.8248L68.6161 27.6413C67.5138 27.6255 66.6838 26.6324 66.8641 25.5447L68.958 12.9131C69.2116 11.3838 67.5438 10.2693 66.2278 11.0886L55.3583 17.8559C54.4224 18.4386 53.1873 18.0518 52.7509 17.0394L47.6833 5.28092Z",
    fill: "#F35C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8456 41.544C62.0935 39.8063 61.172 37.2374 57.8651 36.6373C54.5582 36.0372 52.9106 38.9405 52.4418 41.524",
    stroke: "black",
    strokeWidth: 3.15083,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4268 40.8038C31.1762 39.59 31.8669 36.95 35.2011 36.5273C38.5353 36.1046 40.1338 38.7567 40.8168 41.3394",
    stroke: "black",
    strokeWidth: 3.15083,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4727 49.8127C54.7455 52.3494 51.619 57.2259 44.9302 56.4391C42.6599 56.205 37.7243 54.3842 36.1443 48.9739",
    stroke: "black",
    strokeWidth: 3.15083,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyIcon);
export default __webpack_public_path__ + "static/media/easy-icon.c65303abcf00a3b576ddd95bb0fbc3c1.svg";
export { ForwardRef as ReactComponent };